import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
    truckTrailers: [],
    lorryTrailers:[],
    pickupTrailers:[],
}

export default {
    state,
    getters,
    actions,
    mutations
}
